import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Footer, Header, Meta } from '$partials/global';
import Image from '$partials/media/image';
import IconArrowRight from '$partials/icons/arrow-right';
import ModuleRelatedCarousel from '$partials/modules/individual/related-carousel';
import { useLocale } from '$contexts/locale';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */

const ContactListingPage = ({ data, domain }) => {
    const page = data?.page;

    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <Meta page={page} />

            <main
                className='min-h-screen'
                id='main-content'>

                <Header
                    isOpen={isOpen}
                    menu={data?.navigation}
                    setIsOpen={setIsOpen}/>

                {/* Title */}
                <div className='mt-70 md:mt-85 layout-container'>
                    {page?.title && (
                        <h1 className='px-10 sm:px-5 md:px-10 type-style-1 mb-70 md:mb-90'>{page?.title}</h1>
                    )}

                    {page?.contactCardsHeader && (
                        <h2 className='px-10 sm:px-5 md:px-10 type-style-3 mb-30 sm:mb-40'>{page?.contactCardsHeader}</h2>
                    )}
                </div>

                {/* Contact Cards */}
                {page?.contactCardsCollection?.items?.length > 0 &&
                    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 layout-container gap-y-20 sm:gap-y-10 md:gap-y-20'>
                        {page?.contactCardsCollection?.items?.map((contactCard, i) => {
                            return (
                                contactCard ? (
                                    <div
                                        className='px-10 sm:px-5 md:px-10 w-full h-full'
                                        key={`contact-card-${i}`}>
                                        <a
                                            className='h-full pl-20 pr-40 sm:px-40 py-30 bg-sand rounded-button flex flex-col justify-center gap-20'
                                            href={`contact/${contactCard?.slug}`}>
                                            {contactCard?.listingEyebrowIcon && (
                                                <div
                                                    className='mr-10'
                                                    style={{
                                                        fontSize: '18px',
                                                        width: `${(contactCard.listingEyebrowIcon?.width / contactCard.listingEyebrowIcon?.height)}em` ,
                                                        maxWidth: '100%'
                                                    }}>
                                                    <Image
                                                        {...contactCard.listingEyebrowIcon}
                                                        loading={''}/>
                                                </div>
                                            )}
                                            {contactCard?.title && (

                                                <h3 className='type-style-4'>
                                                    {contactCard?.title}
                                                </h3>
                                            )}
                                            {contactCard?.listingCtaLabel && (
                                                <div className='type-style-7 flex flex-row items-center'>
                                                    {contactCard?.listingCtaLabel}
                                                    <IconArrowRight
                                                        className='ml-10 h-[13px]'
                                                        stroke='black'/>
                                                </div>
                                            )}
                                        </a>
                                    </div>
                                ) : null

                            );
                        })}
                    </div>
                }
                {data?.relatedArticles?.items?.length > 0 && (
                    <div className='mt-80 md:mt-115'>
                        <ModuleRelatedCarousel
                            items={data?.relatedArticles?.items}
                            title={data?.page?.relatedArticlesHeader}/>
                    </div>
                )}
                <div className='layout-container pt-40'>
                    <Footer
                        domain={domain}
                        menu={data?.footer} />
                </div>
            </main>
        </>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */


const propTypes = {
    data: PropTypes.shape({
        page: PropTypes.object,
        navigation: PropTypes.object,
        footer: PropTypes.shape({
            items: PropTypes.array
        }),
        relatedArticles: PropTypes.object,
    }),
    domain: PropTypes.string,
};

ContactListingPage.propTypes = propTypes;

export default ContactListingPage;
